module.exports = __webpack_public_path__ + "img/Flag_of_Ethiopia.120ea455.svg";